module.exports = __webpack_public_path__ + "static/img/40009 (3).aa26ea0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40009 (3).webp
// module id = SlyJ
// module chunks = 14